import { styled } from '@mui/system';
import { Button, MenuItem } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

export const StyledButton = styled(Button)(({ theme }) => ({
  textTransform: 'inherit',
  marginBottom: theme.spacing(1)
}));

export const StyledIcon = styled(DeleteIcon)(({ theme }) => ({
  color: theme.palette.grey[600],
  marginRight: 5
}));

export const StyledMenuItem = styled(MenuItem)(() => ({
  minWidth: 160
}));
